import * as React from 'react';
import CountryService from '../../services/CountryService';

interface IAvailabilityProps {
  availability: GQL.IAvailability;
}

class Availability extends React.Component<IAvailabilityProps> {

  public render() {
    const { language } = CountryService.GetInstance();
    const { availability } = this.props;

    if (!availability) {
      return null;
    }

    const style = {} as any;
    if (availability.color) {
      style.color = availability.color;
    }

    return (
      <span className={'availability'} style={style}>
        {availability.title[language]}
      </span>
    );
  }
}

export default Availability;


// WEBPACK FOOTER //
// ./src/components/Availability/Availability.tsx